import { FormattedMessage } from 'react-intl';
import React from 'react';

const renderMessage = (
  status: number | undefined,
  messages: string[] | undefined
): React.ReactNode => {
  if (messages && messages.length > 0) {
    return <p>{messages.join(' ')}</p>;
  }

  if (!status) {
    return <p>Unfortunately, that's all we know. Please try again.</p>;
  }

  if (status === 400) {
    return (
      <p>
        We got code 400, which means that our server can't work with what we
        sent. Did you submit a form? Please make sure you have completed all
        required fields and try again.
      </p>
    );
  }
  if (status === 500) {
    return (
      <p>
        We got code 500, which means something is broken on our side. We're
        already being alerted of this specific error and will fix it soon!
      </p>
    );
  }
  if (status === 502) {
    return (
      <p>
        We got code 502, which means our server is restarting. We're probably
        pushing out some awesome new features! Just wait a minute or two and try
        again.
      </p>
    );
  }
  if (status === 504) {
    return (
      <p>
        We got code 504, which means our server didn't respond in time. If this
        happened in the context of a Zap, please make sure nothing is blocking
        Zapier from connecting to the apps it uses and try again.
      </p>
    );
  }

  return (
    <p>
      Unfortunately, all we know is that the code was {status}. Please try
      again.
    </p>
  );
};

interface Props {
  summary?: string;
  status?: number;
  messages?: string[];
  isFromContactForm?: boolean;
}

const ErrorInfo = ({
  summary,
  status,
  messages,
  isFromContactForm = false,
}: Props): React.ReactElement => {
  return (
    <div className="dashboard-modal error-modal">
      <h1 className="dashboard-modal__title dashboard-modal__title--small">
        {summary || 'We got an error on that!'}
      </h1>
      <div className="dashboard-modal__content dashboard-modal__content--error">
        {renderMessage(status, messages)}
        <p>
          <FormattedMessage
            defaultMessage="Please"
            id="messages-contact-support-prefix"
          />{' '}
          {/* Here, we do publish our email address, if the error occured on the contact form */}
          <FormattedMessage
            defaultMessage="<component0>contact support</component0> if this persists."
            id="links-contact-support-if-persists"
            values={{
              component0: chunks => (
                <a
                  data-force={isFromContactForm ? 'yes' : 'no'}
                  href="https://developer.zapier.com/contact"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default ErrorInfo;
